// ✅ التحقق من تسجيل الدخول
export const isAuthenticated = () => !!localStorage.getItem("token");

// ✅ profile_completation
export const getProfileStep = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user?.profile_completation || 0;
};

// ✅ تحديد خطوة الإعداد
export const getStepComponent = (step) => {
  switch (step) {
    case 0: return "general-info";
    case 1: return "branches";
    case 2: return "tables";
    case 3: return "storages";
    case 4: return "kitchens";
    case 5: return "pos";
    default: return "dashboard";
  }
};

